import {makeAutoObservable} from "mobx";
import {API_General} from "../api/general";
import jwtDecode from "jwt-decode";
import {roleIdToString} from "../utils/utils";


export class ErrorStore {

    error = ""

    constructor(props) {
        makeAutoObservable(this)
    }

    prepareReport = (error, errorInfo, type) => {

        const loc = window.location
        const storageName = 'userData'
        const data = JSON.parse(localStorage.getItem(storageName))
        const token = data?.token?.token
        const userId = data?.token?.userId
        const jwt = jwtDecode(token)
        const role = roleIdToString(jwt.role)
        return `
        role: ${role}
        type: ${type}
        location: ${loc}
        userId: ${userId}
        error: ${error}
        `
    }

    report = async (message) => {
        const headers = {'Content-Type': 'application/json'}
        const body = JSON.stringify({message})
        const {api, method} = API_General.sendError()
        await fetch(process.env.REACT_APP_BASE_URL + api, {body, method, headers})
    }

    setError = (error, errorInfo, type) => {
        if (window.location.origin === 'https://infocab.net') {
            this.error = error
            this.report(this.prepareReport(error, errorInfo, type))

        }
    }

}

export default new ErrorStore()

